import ky from "ky";

const api = ky.create({
  headers: { "content-type": "application/json;" },
  credentials: "include",
  hooks: {
    beforeRequest: [
      (request, _) => {
        const token = localStorage.getItem("access_token") || "";

        if (token) request.headers.set("Authorization", `Bearer ${token}`);
      },
    ],
  },
});

export default api;
